import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

/* @font-face {
  font-family: "appleFont";
  src: url("./assets/fonts/AppleSDGothicNeoSB.ttf");
} */
  html, body, h1, img {
    margin: 0;
    padding: 0;
    border: 0;
    font-family: 'Noto Sans KR', sans-serif !important;



  
    &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  }

  * {
    outline: none;
  }

  div {
    &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  }

  a {
  text-decoration: none;
  color: inherit;
  }

  input:focus {
    outline: none;
  }

  #chart {
  background: white;
  width: 100%;
  height: 95%;
  margin: 1vw auto;
}


@media (min-width: 3500px) {
    //datepicker 사이즈 조정
    .react-datepicker {
      font-size: 0.8vw !important;
    }
    .react-datepicker__header {
      padding-top: 0.8em;
    }
    .react-datepicker__month {
      margin: 0.4em 1em;
    }
    .react-datepicker__day-name,
    .react-datepicker__day {
      width: 1.9em;
      line-height: 1.9em;
      margin: 0.166em;
    }
    .react-datepicker__current-month {
      font-size: 1em;
    }
    .react-datepicker__navigation {
      top: 1em;
      line-height: 1.7em;
      border: 0.45em solid transparent;
      overflow: visible;
    }
    .react-datepicker__navigation--previous {
      // border-right-color: #ccc;
      left: 1em;
    }
    .react-datepicker__navigation--next {
      // border-left-color: #ccc;
      right: 1em;
    }
    .react-datepicker__navigation-icon::before {
      border-width: 4px 4px 0 0;
      height: 12px;
    }
  }

  @media (min-width: 2500px) {
    //datepicker 사이즈 조정
    .react-datepicker {
      font-size: 0.8vw !important;
    }
    .react-datepicker__header {
      padding-top: 0.8em;
    }
    .react-datepicker__month {
      margin: 0.4em 1em;
    }
    .react-datepicker__day-name,
    .react-datepicker__day {
      width: 1.9em;
      line-height: 1.9em;
      margin: 0.166em;
    }
    .react-datepicker__current-month {
      font-size: 1em;
    }
    .react-datepicker__navigation {
      top: 1em;
      line-height: 1.7em;
      border: 0.45em solid transparent;
      overflow: visible;
    }
    .react-datepicker__navigation--previous {
      // border-right-color: #ccc;
      left: 1em;
    }
    .react-datepicker__navigation--next {
      // border-left-color: #ccc;
      right: 1em;
    }
    .react-datepicker__navigation-icon::before {
      border-width: 4px 4px 0 0;
      height: 12px;
    }
  }
`;
